module.exports = __webpack_public_path__ + "img/post1.9ec6af03.jpg";